import type {DateFilterType} from '../../../../../generated/enums.ts';

export function PeriodFilterNotice(
    {shownCount, totalCount, dateType}: {
        shownCount: number,
        totalCount: number,
        dateType: DateFilterType,
    },
) {
    if (dateType !== 'invoice' || totalCount <= shownCount) {
        return null;
    }

    return (
        <p className="mb-3 text-xs text-gray-500">
            Je ziet {shownCount} van de {totalCount} documenten uit deze periode — de rest heeft nog geen
            factuurdatum of een factuurdatum buiten deze periode.
        </p>
    );
}
